import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import TakebackSummary from "./TakebackSummary";
import { useWindowSize } from "../core-modules/hooks";

function ColumnAndItemSummaryLayout({
  columnContent,
  items,
  donations,
  itemsEditable,
  takebackDetails,
  showSummary = true,
}) {
  const { height: windowHeight } = useWindowSize();

  return (
    <Box
      ml="max(0px,calc(calc(100% - 1280px) / 2))"
      mr={["auto", null, null, 0]}
      display="flex"
      justifyContent="space-between"
      flexDirection={["column-reverse", null, "row", null]}
    >
      <Box
        pl={[null, null, null, "7.75vw"]}
        flex="1 1"
        pr={[null, "4vw", null, null]}
      >
        {columnContent}
      </Box>
      <Box width={[null, "40%", "30%", "25%"]} pb={[50, null, 0, null]}>
        <Box position="sticky" top="20px">
          {takebackDetails}
          {showSummary && (
            <TakebackSummary
              style={{ maxHeight: `${windowHeight - 40}px` }}
              items={items}
              donations={donations}
              itemsEditable={itemsEditable}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

ColumnAndItemSummaryLayout.propTypes = {
  columnContent: PropTypes.node,
  itemsEditable: PropTypes.bool,
  takebackDetails: PropTypes.node,
};

export default ColumnAndItemSummaryLayout;
